import { Raffle } from './../raffle'
import { BreadCrumbActions } from 'src/app/shared/components/breadcrumb/breadcrumb.actions'
import { of, Subscription } from 'rxjs'
import { AppState } from 'src/app/core/core.state'

import { Component, OnDestroy, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { raffleActions } from '../raffle.actions'
import { catchError, filter, map, take, tap, timeout } from 'rxjs/operators'
import { NotificationService } from 'src/app/core/notification.service'
import { persistentUserRoleSelectors } from '../../role/user-role/persistent-user-role/persistent-user-role.selector'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'raffle-create',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class RaffleCreateComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = []
  public subscriptionIds: number[] = []
  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private router: Router,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.actions$
        .pipe(
          ofType(raffleActions.upsertMany),
          tap((action) => {
            action.entities.map((raffle) =>
              this.subscriptionIds?.forEach((subId) => {
                this.store.dispatch(
                  raffleActions.createOneSubscriptionLink({
                    raffleId: raffle.id,
                    subscriptionId: subId
                  })
                )
              })
            )
          })
        )
        .subscribe((action) => {
          action.entities.map((raffle) =>
            this.subscriptionIds?.forEach((subId) => {
              console.log({ raffleId: raffle.id, subscriptionId: subId })

              this.store.dispatch(
                raffleActions.createOneSubscriptionLink({
                  raffleId: raffle.id,
                  subscriptionId: subId
                })
              )
            })
          )

          // if (action.entities.length > 1) {
          //   return this.router.navigate(['/raffles'])
          // } else {
          //   return this.router.navigate(['/raffles', action.entities[0].id])
          // }
        })
    )
  }

  public onSubmit(form): void {
    this.subscriptionIds = Array.isArray(form.subscriptions)
      ? form.subscriptions
      : [form.subscriptions].filter((subscriptionId) => subscriptionId != null)

    delete form.subscriptions

    const entities = []
    if (Array.isArray(form.courseId) && form.courseId.length > 0) {
      this.store
        .select(persistentUserRoleSelectors.selectSelectedUserRole)
        .pipe(take(1))
        .subscribe((pUr) => {
          const siteId =
            pUr && pUr.siteId ? pUr.siteId : environment.defaultSiteId
          form.courseId.forEach((cId) => {
            entities.push({ ...form, courseId: cId, siteId: siteId })
          })
          this.store.dispatch(
            raffleActions.createMany({
              entities: entities
            })
          )
        })
    } else {
      this.store
        .select(persistentUserRoleSelectors.selectSelectedUserRole)
        .pipe(take(1))
        .subscribe((pUr) => {
          const siteId =
            pUr && pUr.siteId ? pUr.siteId : environment.defaultSiteId
          this.store.dispatch(
            raffleActions.createOne({
              entity: {
                ...form,
                siteId: siteId
              }
            })
          )
        })
    }

    this.actions$
      .pipe(
        ofType(raffleActions.upsertMany),
        take(1),
        filter((action) => Boolean(action.entities?.length)),
        map((action) => action.entities[0]),
        timeout(5000),
        catchError((error) => of(null))
      )
      .subscribe((raffle: Raffle) => {
        if (!raffle) {
          return this.notificationService.emit('alerts.error', 'error')
        }
        this.notificationService.emit('alerts.success', 'success')
        this.router.navigate([`/raffles/${raffle.id}`])
      })
  }

  ngOnDestroy() {
    this.subscriptions.map((s) => s.unsubscribe())
  }
}
